export default __webpack_public_path__ + "static/media/AWARIA_OPASKI.00f6cb17.png";